<template>
    <!-- 客户管理 -->
    <div class="saleCustomerManagement reconciliation-main-page">
        <div class="public_Spacing customerManagementPC reconciliation-main-content">
            <div class="pulbic_oparetionBlock reconciliation-filter-card">
                <div class="reconciliation-section-head">
                    <div>
                        <div class="reconciliation-section-title">筛选条件</div>
                        <div class="reconciliation-section-desc">按厂家和账户查询对账余额与最近对账状态</div>
                    </div>
                </div>
                <div class="public_criteriaRange customerManagementPC-select reconciliation-filter-row">
                    <div class="public_oparetionBlock_Menu reconciliation-field">
                        <label class="public_lbSty">厂家名称：</label>
                        <el-select class="public_optionSty dropDown_Define" v-model="ORMTB803ID" filterable
                            placeholder="请选择" @change="factoryChange" clearable>
                            <el-option v-for="item in enterpriseTwoOptionList" :key="item.ORMTB803ID"
                                :label="item.ORMTB803CA01" :value="item.ORMTB803ID">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="public_oparetionBlock_Menu reconciliation-field">
                        <label class="public_lbSty">账户：</label>
                        <el-select class="public_optionSty dropDown_Define" v-model="ORMTB804ID" filterable
                            placeholder="请选择" clearable >
                            <el-option v-for="item in accountList" :key="item.ORMTB804ID" :label="item.ORMTB804CA01"
                                :value="item.ORMTB804ID">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="public_operatBtn reconciliation-filter-actions" style="margin-left: 0px;">
                        <el-button class="public_saleWater_chaxun" type="primary" @click="querycusList">
                            <i class="iconfont icon-chaxun"></i>查询
                        </el-button>

                    </div>
                </div>
            </div>
            <div class="content_box reconciliation-balance-card">
                <div class="reconciliation-balance-label">总余额</div>
                <div class="reconciliation-balance-value">{{ sum }}</div>
            </div>
            <div class="customerManagementPC-table pulbic_oparetionBlock pulbic_table_container reconciliation-table-card">
                <div class="reconciliation-table-head">
                    <div class="reconciliation-section-title">厂家账户列表</div>
                    <div class="reconciliation-section-desc">共 {{ count }} 条记录，可进入单个账户进行对账</div>
                </div>

                <el-table :data="tableData" height="580" style="width: 100%" stripe class="public_tableColumn"
                    :header-cell-style="{ color: 'rgba(51,51,51,1)', background: 'rgba(184,227,255,1)', 'font-weight': 'bold' }">
                    <el-table-column prop="ORMTB803CA01" label="厂家"></el-table-column>
                    <el-table-column prop="ORMTB803CA03" label="厂家对账时间">
                        <template slot-scope="scope">
                            <div>
                                <el-input v-model="scope.row.ORMTB803CA03" @change="updateTime($event, scope.row)"
                                    class="timeInput"></el-input>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="ORMTB804CA01" label="账户"></el-table-column>
                    <el-table-column prop="ORMTB804CA03" label="上次交易时间">
                        <template slot-scope="scope">
                            <div>{{ scope.row.ORMTB804CA03 || '--' }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="ORMTB804CA04" label="上次对账时间">
                        <template slot-scope="scope">
                            <div :class="{ 'overdue': isOverdue(scope.row.ORMTB804CA04) }" v-if="scope.row.ORMTB804CA04">
                                {{ scope.row.ORMTB804CA04 }}</div>
                            <div v-else>--</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="ORMTB804CA05" label="实时余额"></el-table-column>
                    <el-table-column label="对账">
                        <template slot-scope="scope">
                            <div class="customerManagementPC-table-btn">
                                <el-button @click="drzdxqClick(scope.row)" type="primary"
                                    class="public_icon_chongzhi public_icon_width" size="small">对账
                                </el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- </template> -->
                <!-- </RecycleScroller> -->
                <div class="customerManagementPC-page">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40, 100, 200]"
                        layout="total, sizes,prev, pager, next, jumper" :page-size="pagesize" :total="count"></el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import {
// 	Decimal
// } from 'decimal.js';
export default {
    name: 'MainReconciliation',
    data() {
        return {
            cusQueryName: '',
            cusQueryiphone: '',
            options: [],
            cusStatus: '',
            cusStatusList: [],
            tableData: [],
            flag: '',
            page: 1,
            pagesize: 10,
            currentPage: 1,
            count: 0,
            enterpriseTwoOptionList: [
                {
                    SETTB109CA00: '全部',
                    SETTB109ID: '',
                },
            ],
            enterpriseTwo: '',
            userobj: this.$store.state.uobj,
            factoryList: [],
            accountList: [
                {
                    ORMTB804ID: '',
                    ORMTB804CA01: '全部'
                }
            ],
            ORMTB804ID: '',
            ORMTB803ID: '',
            accList: [],
            sum: 0,
        };
    },
    created() {
        var list = "";
        if (this.$route.query.mark != "" && this.$route.query.mark != null) {
            this.userobj = JSON.parse(sessionStorage.getItem("qpUobj"));
            list = JSON.parse(sessionStorage.getItem("qpSolelist"));
            sessionStorage.removeItem('qpUobj');
            sessionStorage.removeItem('qpSolelist');
        } else {
            this.userobj = this.$store.state.uobj;
            list = this.$store.state.solelist;
        }
        var path = this.$route.path;
        if (path === "/reconciliation") {
            path = "/Home" + path;
        }
        this.solelist = this.$baseAPI.querSoleList(list, path); //获取权限列表
        // console.log(this.solelist)
        // 赋值，缓存销毁
        this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl));
        sessionStorage.removeItem(this.currentUrl);
        // if (this.historyInfo != null && this.historyInfo != "") {
        //     this.init();
        // }

        this.optionLists();

    },
    mounted() {
        this.getSum();
        this.querycusList();
    },
    methods: {
        isOverdue(reconciliationTime) {
            if (!reconciliationTime) return false
            const reconciliationDate = new Date(reconciliationTime)
            const currentDate = new Date()
            const timeDiff = currentDate - reconciliationDate
            const daysDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24))
            return daysDiff > 31
        },
        updateTime(e, row) {
            this.axios.post('/orm/ormtb803/updateReconciliationTime', { ORMTB803ID: row.ORMTB803ID, ORMTB803CA03: row.ORMTB803CA03 }).then(res => {
                if (res.data.code == 200) {
                    // this.querycusList();
                } else {
                    this.$message({
                        message: res.data.message,
                        type: 'error'
                    });
                }
            }).catch(() => {
                loading.close();
            })
        },
        getSum() {
            this.axios.post('/orm/ormtb803/queryBalanceSum').then(res => {
                if (res.data.code == 200) {
                    this.sum = res.data.data;
                } else {
                    this.$message({
                        message: res.data.message,
                        type: 'error'
                    });
                }
            }).catch(() => {
                loading.close();
            })
        },
        factoryChange(value) {
            this.ORMTB804ID = '';
            this.getAccountList(value);
        },
        // 获取账户列表
        getAccountList(value) {
            var list = [{
                ORMTB804ID: '',
                ORMTB804CA01: '全部'
            }]

            this.axios.post('/orm/ormtb803/queryAccount', { ORMTB803ID: value }).then(res => {
                if (res.data.code == 200) {
                    var data = res.data.data
                    this.accountList = [...list, ...data];
                    // this.accList = data;
                    // console.log(this.accList,'op900')
                } else {
                    this.$message({
                        message: res.data.message,
                        type: 'error'
                    });
                }
            }).catch(() => {
                loading.close();
            })
        },
        drzdxqClick(row) { //对账
            this.$emit('mainClick', row, this.factoryList, this.accList);
        },
        // 获取下拉框信息--二级企业
        optionLists() {
            var List = [{
                ORMTB803ID: '',
                ORMTB803CA01: '全部',
            }];
            var url = "/orm/ormtb803/queryManuf";
            this.axios.post(url).then(res => {
                if (res.data.code == 200) {
                    var data = res.data.data
                    this.enterpriseTwoOptionList = [...List, ...data];
                    this.factoryList = data;
                } else {
                    this.$message({
                        message: res.data.message,
                        type: 'error'
                    });
                }
            }).catch(() => {
                loading.close();
            })
        },
        querycusList() {//查询信息
            this.tableData = []
            var url = "/orm/ormtb803/queryData"
            var postData = {
                ORMTB803ID: this.ORMTB803ID,
                ORMTB804ID: this.ORMTB804ID,
                page: this.page,
                limit: this.pagesize
            }
            var loading = this.$loading({
                lock: true,
                text: '请求中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            this.axios.post(url, postData).then(res => {
                // console.log(res)
                if (res.data.code == 200) {
                    this.tableData = res.data.data;
                    this.count = res.data.count;
                }
                setTimeout(() => {
                    loading.close()
                }, 300)

            }).catch(() => {
                loading.close()
            })
        },
        handleSizeChange(val) {
            this.pagesize = val;
            this.page = 1;
            this.querycusList();
        },
        handleCurrentChange(val) {
            this.page = val;
            this.querycusList();
        },
    }
};
</script>

<style scoped>
.carDialogTitle {
    font-weight: bold;
    line-height: 60px;
    color: rgb(0, 163, 255);
}

.customerManagementPC {
    background-color: #f3f3f3;
}

.DWD-li {
    display: flex;
    height: 35px;
    line-height: 35px;
    box-sizing: border-box;
    border: 1px solid #999;
    font-size: 16px;
    color: #333;
}

.DWD-li>div {
    padding: 0 5px;
    height: 34px;
    overflow: hidden;
    box-sizing: border-box;
}

.DWD-li-title {
    width: 100px;
    text-align: center;
    border-right: 1px solid #999;
    background-color: rgba(0, 163, 255, .1);
}

.DWD-li+.DWD-li {
    border-top: none;
}

.DWD-table {
    display: flex;
}

.DWD-table-left-flex {
    flex: 1;
}

.DWD-table>div>div {
    padding: 0 5px;
    height: 35px;
    line-height: 35px;
    overflow: hidden;
    text-align: center;
    border-right: 1px solid #999;
    border-bottom: 1px solid #999;
    box-sizing: border-box;
}

.DWD-table>div>div:first-child {
    background-color: rgba(0, 163, 255, .1);
}

.DWD-table-left-title>div {
    width: 101px;
    text-align: center;
    background-color: rgba(0, 163, 255, .1);
}

.DWD-table .DWD-table-left-title>div {
    padding: 0 5px;
    height: 35px;
    line-height: 35px;
    overflow: hidden;
    box-sizing: border-box;
    border-left: 1px solid #999;
    border-bottom: 1px solid #999;
}

.DetailsWater-img {
    margin-top: 30px;
}

.DetailsWater-img-text {
    display: inline-block;
    width: 101px;
    text-align: center;
    vertical-align: top;
}

.customerManagementPC-select .public_oparetionBlock_Menu:first-child {
    margin-left: 0;
}

.customerManagementPC-btn {
    text-align: left;
    margin-bottom: 20px;
}

.customerManagementPC-btn i {
    margin-right: 10px;
}

.customerManagementPC-table {
    padding: 30px 20px 0;
}

.customerManagementPC-table-btn i {
    font-size: 12px;
    margin-right: 5px;
}


.public-chech-details-table {
    margin-top: 20px;
    max-height: 500px;
    overflow-y: auto;
}

.public-chech-details-table-no-text {
    line-height: 80px;
    text-align: center;
    border-bottom: 1px solid #cdcdcd;
}

.customerManagementPC-page {
    margin-top: 20px;
    text-align: right;
}

.CustomerfillingDig-priceNumtext {
    font-weight: 500;
    font-size: 18px;
    line-height: 40px;
    padding: 20px 0 20px 10px;
    color: #333;
}

.CustomerfillingDig-priceNumtext span {
    color: rgba(175, 181, 4, 1.0);
    margin-left: 10px;
    font-size: 20px;
}

.fontBlue {
    color: rgba(25, 159, 255, 1) !important;
}

.billOperationRecord {
    background-color: #f3f3f3;
}

.billOperationRecord-border {

    /* border-top: 2px solid rgba(205,205,205,.4); */
    border-top: none;
    box-sizing: border-box;
    margin-right: 40px;
}

.billOperationRecord th,
.billOperationRecord td {
    text-align: center;
}

.customerRecharge-table {
    box-sizing: border-box;
}

.CustomertopUpDig-content-table-btn>.public_saleWater_lieSet {
    border-color: rgba(254, 172, 0, 1) !important;
}


.billOperationRecord-page {
    padding-right: 40px;
    text-align: right;
    margin-top: 20px;
    padding-bottom: 20px;
}

.salesWatersStatisticsPC-saleWaterDetails-btn {
    margin-bottom: 20px;
}

.salesWatersStatisticsPC-saleWaterDetails-btn i {
    margin-right: 10px;
}

.el-dropdown-link {
    cursor: pointer;
}

.el-table--scrollable-y .el-table__body-wrapper {
    overflow: auto;
}

.public_tableColumn .el-table__body-wrapper {
    overflow: auto !important;
}

.public_icon_width {
    width: 80px;
}

.levelmang-title {
    display: flex;
    color: #333;
    text-align: center;
    margin-bottom: 20px;

}

.levelmang-title div {
    padding: 10px 20px;
    background-color: #e3e3e3;
}

.levelmang-title .levelmang-title-active {
    background-color: #199FFF;
    color: #FFF;
}

.levelmang-table {
    border: 1px solid #e3e3e3;
}

.levelmang-table>li {
    display: flex;
}

.levelmang-table-head {
    text-align: center;
    background-color: #30A8FF;
    color: #FFF;
}

.levelmang-table-head>div {
    height: 50px;
    line-height: 50px;
    border-left: 1px solid #e3e3e3;
    box-sizing: border-box;
    overflow: hidden;
}

.levelmang-table-head>div:first-child {
    border: none;
}

.levelmang-table-CQ {
    flex: 1;
    position: relative;
    padding: 5px 10px;
}

.levelmang-table-CQ-list {
    border-bottom: 1px solid #e3e3e3;
}

.levelmang-table-JB {
    width: 240px;
}

.levelmang-table-KJ,
.levelmang-table-ZK,
.levelmang-table-YH {
    width: 295px;
}

.levelmang-table-ZK input,
.levelmang-table-YH input {
    text-align: center;
}

.levelmang-table-li {
    text-align: center;
}

.levelmang-table-li-tab-li {

    border-bottom: 1px solid #e3e3e3;
}

.levelmang-table-li-tab-li:last-child {
    /* border: none; */
}

.levelmang-table-li-tab-li>div {
    border-left: 1px solid #e3e3e3;
    padding: 0 10px;
    box-sizing: border-box;
    height: 50px;
    line-height: 50px;
    vertical-align: top;
    overflow: hidden;
}

.levelmang-table-li-tab-li>div>input {
    width: 100px;
    border: 1px solid #e3e3e3;
    height: 35px;
    line-height: 35px;
    border-radius: 5px;
    margin-right: 10px;
}

.levelmang-table-CQ>div {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 100%;
    transform: translate(-50%, -50%);
}

.levelmang-table-li-tab-li {
    display: flex;
}



.shouQuanChangJia-dialog .el-checkbox {
    margin-bottom: 15px;
}

/deep/ .num .el-input .el-input__inner {
    font-size: 18px !important;
}

::v-deep .addPointer {
    cursor: pointer;
}

::v-deep .success-row {
    background-color: #81d3f8 !important;
}

.content_box {
    width: 25%;
    padding: 25px;
    box-sizing: border-box;
    background-color: #fff;
    text-align: center;
    color: rgb(235, 170, 122);
    font-size: 20px;
}

.timeInput /deep/.el-input__inner {
    text-align: center !important;
}
.overdue {
  color: #ff4d4f;
}
.public_lbSty {
    width: auto!important;
}

.reconciliation-main-page {
    min-height: 100%;
    background: linear-gradient(180deg, #f6faff 0%, #eef5fb 100%);
}

.reconciliation-main-content {
    padding: 16px;
    background: transparent;
    box-sizing: border-box;
}

.reconciliation-filter-card,
.reconciliation-balance-card,
.reconciliation-table-card {
    position: relative;
    border: 1px solid rgba(217, 231, 243, .96);
    border-radius: 16px;
    background: rgba(255, 255, 255, .96);
    box-shadow: 0 8px 24px rgba(31, 93, 154, .08);
}

.reconciliation-filter-card::after,
.reconciliation-table-card::after {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    height: 3px;
    border-radius: 16px 16px 0 0;
    background: linear-gradient(90deg, #3aa0ff, rgba(53, 199, 166, .72), transparent);
    content: '';
}

.reconciliation-filter-card {
    margin-bottom: 14px;
    padding: 16px 18px;
}

.reconciliation-table-head {
    padding-top: 8px;
    padding-right: 12px;
}

.reconciliation-section-head,
.reconciliation-table-head {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    margin-bottom: 14px;
}

.reconciliation-section-title {
    position: relative;
    padding-left: 12px;
    color: #183b5b;
    font-size: 18px;
    font-weight: 800;
    line-height: 1.2;
}

.reconciliation-section-title::before {
    position: absolute;
    top: 2px;
    left: 0;
    width: 4px;
    height: 18px;
    border-radius: 4px;
    background: #2689e8;
    content: '';
}

.reconciliation-section-desc {
    margin-top: 6px;
    padding-left: 12px;
    color: #7b8fa6;
    font-size: 13px;
}

.reconciliation-filter-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px 18px;
    margin: 0 !important;
    padding: 0 !important;
}

.reconciliation-field {
    display: flex;
    align-items: center;
    min-height: 36px;
    margin: 0 !important;
    padding: 0 !important;
}

.reconciliation-main-page .public_lbSty {
    display: inline-flex;
    align-items: center;
    justify-content: flex-end;
    min-width: 70px;
    height: 36px;
    margin: 0 !important;
    color: #51687f;
    font-size: 14px;
    font-weight: 700;
    line-height: 36px;
}

.reconciliation-main-page .public_optionSty {
    width: 260px;
}

.reconciliation-main-page /deep/ .el-input__inner {
    height: 36px !important;
    line-height: 36px !important;
    border-color: #d9e7f3;
    border-radius: 9px;
}

.reconciliation-filter-actions {
    display: flex;
    align-items: center;
    margin-left: auto !important;
}

.reconciliation-filter-actions /deep/ .el-button {
    min-width: 86px;
    height: 36px;
    padding: 0 18px;
    border: none;
    border-radius: 18px;
    font-weight: 700;
    background: linear-gradient(135deg, #3aa0ff, #1976d2);
    box-shadow: 0 6px 14px rgba(38, 137, 232, .24);
}

.reconciliation-balance-card {
    width: 260px;
    margin-bottom: 14px;
    padding: 18px 20px;
    color: #183b5b;
    text-align: left;
}

.reconciliation-balance-label {
    color: #7b8fa6;
    font-size: 13px;
    font-weight: 700;
}

.reconciliation-balance-value {
    margin-top: 8px;
    color: #e28a43;
    font-size: 28px;
    font-weight: 900;
    line-height: 1.1;
}

.reconciliation-table-card {
    padding: 16px 18px 14px;
    overflow: visible;
}

.reconciliation-table-card /deep/ .el-table {
    border: 1px solid #e3edf7;
    border-radius: 12px;
    overflow: hidden;
}

.reconciliation-table-card /deep/ .el-table th {
    background: #f0f7ff !important;
    color: #24435f !important;
    font-weight: 800;
}

.reconciliation-table-card /deep/ .el-table td,
.reconciliation-table-card /deep/ .el-table th {
    padding: 10px 0;
    border-bottom-color: #edf3fa;
}

.reconciliation-table-card /deep/ .el-table__row:hover > td {
    background: #f7fbff !important;
}

.reconciliation-table-card .customerManagementPC-page {
    position: relative;
    z-index: 5;
    display: flex;
    justify-content: flex-end;
    margin-top: 0;
    padding: 14px 0 0;
    overflow: visible;
}

.overdue {
  color: #ff4d4f;
  font-weight: 700;
}
</style>